import React, { useState, useEffect, useContext } from "react";
import "../styles/filing.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import DynamicIcon from "../components/dynamicicon";
import JisButton from "../components/controls/jisButton";
import JisDropdown from "../components/controls/jisDropdown";
import FlowItem from "../components/controls/flowitem";
import { ShareContext } from "../context/ShareContext";
import Gazette from "../components/core/gazette";
import * as Constants from "../constants";
import BackLoader from "../components/backloader";
import Payment from "../components/core/payment";
import JisDialog from "../components/dialog";
import { ChevronDown } from "lucide-react";

function FilingClaim() {
  const FeeTYPEID = 31;
  const navigate = useNavigate();
  const { caseid } = useParams();

  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cinfo, setCase] = useState(null);
  const [flow, setFlow] = useState({ pos: 1, code: "claims" });
  const [flowerror, setFlowError] = useState("");
  const [casefeeId, setcasefeeId] = useState(null);
  const [parties, setParties] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [claimtitle, setClaimTitle] = useState("Claim"); //so we can set if its Claim, Counter claim or Offence
  const [claims, setClaims] = useState([
    { claim: "", claimValue: "", currencyType: "" },
  ]);
  const [claimids, setclaimIds] = useState("");
  const currencies = [
    { label: "Naira (N)", value: "Naira" },
    { label: "Dollar ($)", value: "Dollar" },
    { label: "Euro (e)", value: "Euro" },
    { label: "Pound", value: "Pound" },
  ];
  const [removingIndex, setRemovingIndex] = useState(null);

  const onChangeClaim = (index, key, value) => {
    setClaims((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [key]: value } : item))
    );
  };

  const onRemoveClaims = async (index) => {
    if (claims.length == 1) {
      return;
    }

    const h = claims[index];
    if (h && h.id > 0) {
      await onRemoveClaim_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setClaims((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };

  const onAddClaim = () => {
    setClaims((prev) => [
      ...prev,
      { claim: "", claimValue: "", currencyType: "" },
    ]);
  };
  const onRemoveClaim_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-claim/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onGazetteProceed = (e) => {
    console.log("after processing... here is value");
    console.log(e);
    setcasefeeId(e.feeid);
    setIsSuccess(e.isPaid);
    if (!e.isPaid) {
      on_gazette();
    }
  };
  const on_gazette = () => {
    setFlow({ pos: 3, code: "payment" });
  };
  const on_payment_back = () => setFlow({ pos: 2, code: "gazette" });

  useEffect(() => {
    if (caseid != null) {
      onLoad(caseid);
    }
  }, [caseid]);
  const onLoad = async (_caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/mini-case-details/${_caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCase(data.caseinfo);
        setParties(data.parties.filter((c) => c.legalCounselId == profile.id));
        setIsLoaded(true);
        var cc = data.caseinfo?.caseTypeId == 2 ? "Offences" : "Claims";

        if (profile.id != data.caseinfo.createdById) {
          setClaimTitle(`Counter ${cc}`);
        } else {
          setClaimTitle(cc);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const on_claims = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/claim/${caseid}`, {
        method: "POST",
        body: JSON.stringify(claims),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        //setGazettes(data.gazettes);
        setFlow({ pos: 2, code: "gazette" });
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onGotoDetails = () => {
    setIsSuccess(false);
    navigate(`/document-upload/${casefeeId}`); //navigate to login
  };
  return (
    <div
      style={{
        maxWidth: flow.code == "claims" && "600px",
        width: "100%",
        margin: "auto",
      }}
    >
      {/* <div style={{ textAlign: "center" }}>
        <h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo?.caseNumber}</h3>
      </div> */}
      <div className="multiform filing-claims">
        <div className="flow">
          <div className="itemgroup">
            <FlowItem
              flow={flow}
              pos={1}
              code="claims"
              title={`${claimtitle} Details`}
            />
            <FlowItem flow={flow} pos={2} code="gazette" title="Gazette" />
            <FlowItem
              flow={flow}
              pos={3}
              code="payment"
              title="Payment"
              isLast={true}
            />
          </div>
        </div>
        {flow.code == "claims" && (
          <div className="view fill-form-container">
            <form onSubmit={on_claims}>
              {claims.map((claim, index) => (
                <div
                  key={index}
                  className={`claim-item ${
                    removingIndex === index ? "removing" : ""
                  }`}
                >
                  <div onClick={() => onRemoveClaims(index)} className="delete">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.0002 6.73046C20.9802 6.73046 20.9502 6.73046 20.9202 6.73046C15.6302 6.20046 10.3502 6.00046 5.12016 6.53046L3.08016 6.73046C2.66016 6.77046 2.29016 6.47046 2.25016 6.05046C2.21016 5.63046 2.51016 5.27046 2.92016 5.23046L4.96016 5.03046C10.2802 4.49046 15.6702 4.70046 21.0702 5.23046C21.4802 5.27046 21.7802 5.64046 21.7402 6.05046C21.7102 6.44046 21.3802 6.73046 21.0002 6.73046Z"
                        fill="#FF2E3B"
                      />
                      <path
                        d="M8.49977 5.72C8.45977 5.72 8.41977 5.72 8.36977 5.71C7.96977 5.64 7.68977 5.25 7.75977 4.85L7.97977 3.54C8.13977 2.58 8.35977 1.25 10.6898 1.25H13.3098C15.6498 1.25 15.8698 2.63 16.0198 3.55L16.2398 4.85C16.3098 5.26 16.0298 5.65 15.6298 5.71C15.2198 5.78 14.8298 5.5 14.7698 5.1L14.5498 3.8C14.4098 2.93 14.3798 2.76 13.3198 2.76H10.6998C9.63977 2.76 9.61977 2.9 9.46977 3.79L9.23977 5.09C9.17977 5.46 8.85977 5.72 8.49977 5.72Z"
                        fill="#FF2E3B"
                      />
                      <path
                        d="M15.2099 22.7496H8.7899C5.2999 22.7496 5.1599 20.8196 5.0499 19.2596L4.3999 9.18959C4.3699 8.77959 4.6899 8.41959 5.0999 8.38959C5.5199 8.36959 5.8699 8.67959 5.8999 9.08959L6.5499 19.1596C6.6599 20.6796 6.6999 21.2496 8.7899 21.2496H15.2099C17.3099 21.2496 17.3499 20.6796 17.4499 19.1596L18.0999 9.08959C18.1299 8.67959 18.4899 8.36959 18.8999 8.38959C19.3099 8.41959 19.6299 8.76959 19.5999 9.18959L18.9499 19.2596C18.8399 20.8196 18.6999 22.7496 15.2099 22.7496Z"
                        fill="#FF2E3B"
                      />
                      <path
                        d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
                        fill="#FF2E3B"
                      />
                      <path
                        d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
                        fill="#FF2E3B"
                      />
                    </svg>

                    <p>Delete</p>
                  </div>
                  <div className="form-content">
                    <div className="input-group">
                      <label>
                        {" "}
                        {claimtitle} <span className="required">*</span>{" "}
                      </label>
                      <div className="input-wrapper">
                        {/* <DynamicIcon iname="group" /> */}
                        <input
                          placeholder="Money Laundering"
                          required={true}
                          value={claim.claim}
                          onChange={(e) =>
                            onChangeClaim(index, "claim", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    {cinfo?.caseTypeId != 2 && (
                      <div className="form-row">
                        <div className="select-group">
                          <label>Currency Type</label>
                          <div className="select-wrapper">
                            <select
                              name="gender"
                              value={claim.currencyType}
                              required={claim.claimValue && claim.claimValue.trim() !== ""}
                              onChange={(e) =>
                                onChangeClaim(
                                  index,
                                  "currencyType",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select </option>
                              {currencies.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>

                            <ChevronDown size={24} className="select-icon" />
                          </div>
                        </div>

                        <div className="input-group">
                          <label> Claim Value (Numbers only) </label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="money" />
                            <input
                              required={claim.currencyType && claim.currencyType !== ""}
                              placeholder="N3,000,000.00"
                              value={Constants.formatCurrency(claim.claimValue)}
                              onChange={(e) =>
                                onChangeClaim(
                                  index,
                                  "claimValue",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <button
                className="fill-btn-outline "
                type="button"
                onClick={onAddClaim}
              >
                Add {claimtitle}
              </button>
              {/* <JisButton icon="add" onClick={onAddClaim}>Add {claimtitle}</JisButton> */}

              <div className="flowbuttongroup">
                {/* <JisButton type="submit" loading={loading}>
                  Proceed
                </JisButton> */}

                <button
                  className="fill-btn-solid "
                  type="submit"
                  loading={loading}
                >
                  Continue
                </button>
              </div>
            </form>
          </div>
        )}
        {flow.code == "gazette" && (
          <div className="view">
            <Gazette
              filingtypeid={cinfo?.caseFilingId}
              levelid={cinfo?.caseCategoryId}
              feetypeid={FeeTYPEID}
              token={token}
              onProceed={(e) => onGazetteProceed(e)}
              caseid={cinfo?.caseId}
              feeId={casefeeId}
            >
              {/* <div className="top-nav">
                <div className="left-top">
                  <div className="top">
                    <h2>
                      {cinfo?.referenceNumber} |{" "}
                      {
                        Constants.getItemById(
                          frequentData.casecategories,
                          cinfo?.caseCategoryId
                        )?.categoryTitle
                      }
                    </h2>
                  </div>
                  <p>Select items related to the {claimtitle}</p>
                </div>
                <p className="nav-status">
                  {claimtitle} Filing /Specifications
                </p>
              </div> */}
            </Gazette>
          </div>
        )}
        {flow.code == "payment" && (
          <div className="view">
            <Payment feeid={casefeeId} token={token} />

            {/* <div className="flowbuttongroup">
              <JisButton onClick={on_payment_back}>Back</JisButton>
            </div> */}
          </div>
        )}
      </div>

      <BackLoader open={loading} />
      {isSuccess && (
        <JisDialog title="Case Created Successfully.">
          <div>
            Additional Claim/Counter Claim created successfully. Payment is not
            required. Please continue to upload document
          </div>
          <JisButton onClick={onGotoDetails}>Upload document</JisButton>
        </JisDialog>
      )}
    </div>
  );
}

export default FilingClaim;
